import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().nullable().required('Name is required'),
  organizationId: Yup.number().nullable().required('Organization is required'),
  orderMappingRules: Yup.array().of(
    Yup.object().shape({
      mappingPropertyId: Yup.number().when('required', {
        is: true,
        then: Yup.number().nullable().required('Mapping Property Id is required'),
        otherwise: Yup.number().nullable()
      }),
      columnName: Yup.string().when('required', {
        is: true,
        then: Yup.string().nullable().required('Column Name is required'),
        otherwise: Yup.string().nullable()
      }),
      fixedValue: Yup.string().when(['required', 'columnName'], {
        is: (required, columnName) => required && (!columnName || !columnName.length),
        then: Yup.string().nullable().required('Fixed Value is required'),
        otherwise: Yup.string().nullable()
      })
    })
  )
});
